import styled from '@emotion/styled';
import { Body } from '@components/templates/PageBody';
import { icons } from '@assets/icons';
import { css } from '@emotion/react';

export const LicenseRegistrationBody = styled(Body)`
  margin-top: 15px;
  min-width: 505px;
  table {
    width: 100%;
    tbody > tr > td {
      background-color: #fafafa;
    }
  }
`;
export const LicenseRegistrationTable = styled.table`
  border-spacing: 1px;
  thead {
    background: #ffffff;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #999999;
    tr {
      height: 60px;
      th {
        border-bottom-width: 4px;
        border-bottom-style: solid;
        border-bottom-color: #e0e0e0;
        width: 50%;
        position: relative;
        text-align: left;
        padding-left: 75px;
        &:before {
          position: absolute;
          margin-left: calc(-24px - 10px);
          justify-content: center;
          align-items: center;
          content: '';
          background: no-repeat center / 70% 70%;
          background-color: #999999;
          width: 24px;
          height: 24px;
          border-radius: 24px;
        }
        &[data-type='code']:before {
          background-image: url(${icons.enter_code});
        }
        &[data-type='activate']:before {
          background-image: url(${icons.select_type});
        }

        &[data-status='wait'] {
          color: #333333;
          border-bottom-color: #7fe200;
        }

        &[data-status='active'] {
          color: #333333;
          border-bottom-color: #7fe200;
          :before {
            background-color: #00bf00;
          }
        }
        &[data-status='complete'] {
          color: #ffffff;
          background-color: #00bf00;
          border-bottom-color: #7fe200;
          &:before {
            background-image: url(${icons.check});
            background-color: #7fe200;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        height: 240px;
      }
    }
  }
  tfoot {
    background: unset;
    button {
      margin: 10px 0 0 auto;
    }
  }
`;
export const ImportWrapper = styled.div`
  padding: 40px;
  button {
    margin: 20px auto;
  }

  & div {
    & input {
      width: 100%;
      padding-right: 140px;
      border-radius: 5px;
      border-right-width: 1px;
      &:focus-visible {
        border-right-width: 1px;
      }
      &:focus,
      &:active {
        & + div {
          & + label {
            border-color: #7fe200;
          }
        }
      }
    }
    & input[data-invalid] {
      &:not([data-invalid='']) {
        & + div {
          & + label {
            border-color: #ff4c4c;
          }
        }
      }
    }

    & input[data-invalid] {
      &:is([data-invalid='']) {
        & + div {
          & + label {
            border-color: #7fe200;
          }
        }
      }
    }

    & label[for='txt-upload-input'] {
      position: absolute;
      top: 1px;
      right: 1px;
      height: 38px;
      width: 124px;
      border: none;
      border-left: 1px solid #e0e0e0;
    }
  }
`;

export const ImportDesc = styled.div`
  margin-bottom: 14px;
  text-align: left;
`;

export const ActivateTypeWrapper = styled.div`
  & > div {
    display: flex;
    align-items: center;
    height: 40px;
  }
`;

export const ValidationStyle = css`
  input[data-invalid='true' i]:invalid {
    border-color: red !important;
    position: relative;
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        content: 'Please enter the ID.';
        color: red;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }
`;
